/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges} from '@angular/core';
import * as _ from 'lodash';

@Component({
  standalone: false,
  selector: 'adn-ad-unit-matching-label-target-summary',
  template: '{{data}}'
})
export class AdUnitMatchingLabelSummaryComponent implements OnChanges {
  @Input() targets: any;

  data = '';

  ngOnChanges(): void {
    const target = this.targets || {};
    const labels = _.sortBy(_.map(target, (t) => t.matchingLabels[0]));
    this.data = labels.join(', ');
  }
}
